import React from 'react';
import PropTypes from 'prop-types';

export default function ModalTitle({ children, bgColor = 'white' }) {
	return <div className={`modal-title ${bgColor}`}>{children}</div>;
}

ModalTitle.propTypes = {
	children: PropTypes.node,
	bgColor: PropTypes.oneOf(['white', 'navyBlue', 'secondaryBlue']),
};
